import { useTranslation } from 'react-i18next'
import type { GoalStatus } from 'core/api/current-week/useApiGetCurrentWeekGoalIndicators'
import { useFormatAmount } from 'core/hooks/useFormatAmount'

interface GoalStatusLabelProps {
  goalStatus: GoalStatus
  probable: number
  forecasted: number
  currency: string
}

const getTranslationKey = (goalStatus: GoalStatus): string => {
  switch (goalStatus) {
    case 'BAD':
    case 'MEDIUM':
      return 'general.homepage.weekly-goal.status-description-bad'
    case 'GOOD':
      return 'general.homepage.weekly-goal.status-description-good'
  }
}

const GoalStatusDescription = ({ goalStatus, forecasted, probable, currency }: GoalStatusLabelProps) => {
  const { t } = useTranslation()
  const formatAmount = useFormatAmount()
  const diff = forecasted - probable

  return (
    <div className="vp-caption mg-weekly-goal-status-description">
      {t(getTranslationKey(goalStatus), {
        forecasted: formatAmount(forecasted, currency),
        probable: formatAmount(probable, currency),
        diff: formatAmount(diff, currency)
      })}
    </div>
  )
}

export default GoalStatusDescription
